import Dev from './Dev';
import Prod from './Prod';

export default process.env.REACT_APP_ENVIRONMENT === 'development' ? Dev : Prod;
